/** Created by azhou on 2019/3/13.*/
<template>
    <div>
        <div v-if="isGroup && !queryCon.GST">
            <gcon-search @getSearchCon="getSearchCon" />
            <p v-if="StoreLists.total<=0">当前没有数据</p>
            <div v-else>
            <ul class="list-head"><li class="w-50" v-for="item in titleArr" :key="item">{{item}}</li></ul>
            <ul class="list-item" v-for="Itemize in StoreLists.lists" :key="Itemize.id">
                <li class="w-50 list-item-col">
                <span class="text-link" @click="goStoreDetail(Itemize.store_id)">{{Itemize.title}}</span>
                </li>
                <li class="w-50 list-item-col">{{Itemize.dealMoney}}</li>
                <li class="w-50 list-item-col">{{Itemize.exp}}</li>
                <li class="w-50 list-item-col" :class="[Itemize.verify === 1 ? 'text-success' : 'text-danger']">
                {{Itemize.verify | formatVar('verifyType')}}
                </li>
                <li class="w-50 list-item-col">
                {{Itemize.province_name}}-{{Itemize.city_name}}-{{Itemize.district_name}}
                </li>
                <li class="w-50 list-item-col-end">
                <span class="text-link" @click="goForDetail(Itemize)">查看</span>
                </li>
            </ul>
            <el-pagination background layout="prev, pager, next" class="mt-4"
                :total="StoreLists.total" :current-page="Number(queryCon.page)"
                @current-change="v => this.$router.push({name:this.$route.name,query:{page:v}})"/>
            </div>
        </div>
        <itemize-credit v-for="(item,index) in CreditList.lists" :key="index" :Itemize="item" v-else />
    </div>
</template>

<script>
  import { mapGetters,mapState, mapActions } from 'vuex'
  import ItemizeCredit from './ItemizeCredit'
  import GconSearch from '../../StoreInfo/GconSearch'

  export default {
    name: 'GroupCollectManage',
    components: { ItemizeCredit,GconSearch },
    computed: {
      ...mapState(['StoreLists','CreditList']),
      ...mapGetters(['storeInfo','isGroup']),
      queryCon() { return this.$route.query }
    },
    watch:{
      queryCon() { if (this.isGroup) this.TraGroupGetStoreLists({ url: this.url, data: {...this.info} }) },
    },
    data() {
      return {
        titleArr:['门店名称','成交订单金额','累计积分','门店认证','所在地','操作'],
        info: {},
        url: '/pc/Travel/getStoreExpDetail'
      }
    },
    created() {
        if (this.isGroup) {
            if (this.queryCon.hasOwnProperty('page')) this.TraGroupGetStoreLists({ url: this.url})
            else this.TraGroupGetStoreLists({ url: this.url, data: {page:1} })
        }
    },
    methods:{
      ...mapActions(['TraGroupGetStoreLists']),
      //查看门店发票列表
      goForDetail(item) {
        this.$router.push({name:this.$route.name,query:{...this.$route.query,storeId:item.id,GST:item.title}})
      },
      //查看门店详情页
      goStoreDetail(id) {
        let routeUrl = this.$router.resolve({name:'StoreDetail',query:{type:this.storeInfo.type,id}});
        window.open(routeUrl.href, '_blank');
      },
      getSearchCon (info) {
        this.info=info;
        this.TraGroupGetStoreLists({ url: this.url, data: {page:1, ...info} })
      }
    }
  }
</script>
